import React from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./components//Home";
import TransactionsComponent from "./components/Transactions";
import ReceivesComponent from "./components/Receives";
import DispTransComponent from "./components/DispTransactions";
import OutflowCompareComponent from "./components/OutflowCompare";
import DispVSLevelComponent from "./components/DispVSLevel";
import ReconDailySnapshotComponent from "./components/ReconDailySnapshot";
import Login from "./components/Login";
import ShiftReportComponent from "./components/ShiftReport";

function App() {
  return (
     <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/transactions" element={<TransactionsComponent />} />
        <Route path="/disptrans" element={<DispTransComponent />} />
        <Route path="/disptranslevel" element={<DispVSLevelComponent />} />
        <Route path="/outflowcomp" element={<OutflowCompareComponent />} />
        <Route path="/receives" element={<ReceivesComponent />} />
        <Route path="/recondaily" element={<ReconDailySnapshotComponent/>} />
        <Route path="/shiftreport" element={<ShiftReportComponent/>} />
      </Routes>
    </Router>
  );
}

export default App;
